// Page module: the signature pad (signatures#edit).
//
// Two steps when the signature has a brief (see app/models/signature_brief.rb):
// read what you are confirming and make the choice that is yours, THEN sign.
// Without a brief it is one step and behaves exactly as it always did.

global.signature = {
  data: { needed: 0, lastWidth: null },
  init: function() {
    signature.data.canvas = document.querySelector("canvas");
    signature.data.pad = new SignaturePad( signature.data.canvas);
    window.onresize = signature.onResize;

    var $brief = $('#signature-brief');
    signature.data.needed = parseInt($brief.data('needed'), 10) || 0;

    context = {
      // the brief reads fine in portrait; only the pad needs landscape
      step: $brief.length > 0 ? 'brief' : 'pad',
      showPad: function() {
        return window.innerHeight < window.innerWidth;
      }
    };

    $('.submit-btn').click(signature.submit);
    $('.clear-btn').click(signature.clear);
    $('#brief-continue').click(signature.toPad);
    $('.starting-pick').change(signature.refreshPicks);
    signature.refreshPicks();

    signature.resizeCanvas();
  },
  // Show how many are picked and block the way forward until the count is
  // right. The server checks it again — this is so the coach is not guessing.
  refreshPicks: function() {
    if(signature.data.needed === 0) return;

    var picked = $('.starting-pick:checked').length;
    var ok = picked === signature.data.needed;
    $('#starting-count').text(picked + ' / ' + signature.data.needed)
      .toggleClass('badge-success', ok).toggleClass('badge-secondary', !ok);
    $('#brief-continue').prop('disabled', !ok);
  },
  toPad: function() {
    setContext('step', 'pad');
    refreshContext();
    signature.resizeCanvas();
  },
  // A phone hides and shows its address bar while the coach scrolls the brief,
  // and every one of those is a window resize. Redoing the canvas then would
  // wipe an in-progress signature, and the scrollTo(0,0) yanked the brief back
  // to the top mid-scroll. Only a WIDTH change (rotating the phone, a real
  // window resize) touches the pad; a height-only resize just re-evaluates the
  // orientation prompt.
  onResize: function() {
    refreshContext();
    if(context.step !== 'pad') return;
    if(window.innerWidth === signature.data.lastWidth) return;
    signature.resizeCanvas();
  },
  resizeCanvas: function() {
    refreshContext();
    setTimeout(function() {
      if(context.step !== 'pad') return;
      signature.data.lastWidth = window.innerWidth;
      var w = $('#signature-pad').width();
      signature.setPadSize(w);
      signature.clear();
      signature.data.canvas.width = w;
      signature.data.canvas.height = window.innerHeight - $('#signature-pad-header').outerHeight() - $('#signature-pad-footer').outerHeight() - 5;
      window.scrollTo(0, 0);
    }, 300);
  },
  clear: function() {
    signature.data.pad.clear();
  },
  submit: function(e) {
    e.preventDefault();
    $('form input[name="base64_image"]').val(signature.data.pad.toDataURL());
    $('form').submit();
  },
  setPadSize: function(w) {
    var size = w/200 + 1; // set in the way that: 1800 -> 10, 600 -> 4
    signature.data.pad.minWidth = size;
    signature.data.pad.maxWidth = size;
  }
}
